import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  postPowerBiPage,
  postPowerBiReport,
} from '../contentLibrary/libraryItemService';

export const initialState = {
  loading: false,
  error: null,
  libraryItemId: null,
};

export const savePowerBiReport = createAsyncThunk(
  'powerBiReports/savePowerBiReport',
  async ({ projectId, allTabsSelected, PBIItem }) => {
    let postPBI;
    if (allTabsSelected) {
      postPBI = await postPowerBiReport(
        projectId,
        PBIItem.reportId,
        PBIItem.name
      );
    } else {
      postPBI = await postPowerBiPage(
        projectId,
        PBIItem.reportId,
        PBIItem.pageName,
        PBIItem.pageDisplayName
      );
    }
    return postPBI;
  }
);

const savePowerBiReportSlice = createSlice({
  name: 'savePowerBiReport',
  initialState,
  reducers: {},
  extraReducers: {
    [savePowerBiReport.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [savePowerBiReport.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.libraryItemId = payload;
    },
    [savePowerBiReport.rejected]: (state, { error }) => {
      state.loading = false;
      state.error = error;
      state.libraryItemId = null;
    },
  },
});

export const { reducer: savePowerBiReportReducer } = savePowerBiReportSlice;

export const savePowerBiReportSelector = (state) => state.savePowerBiReport;
